import { render, staticRenderFns } from "./ModalConfirmUpdatePublish.vue?vue&type=template&id=13632550&"
import script from "./ModalConfirmUpdatePublish.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmUpdatePublish.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmUpdatePublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports